export function isPWA(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const nav = window.navigator as Navigator & { standalone?: boolean };
  if (nav.standalone === true) {
    return true;
  }

  return window.matchMedia(
    '(display-mode: standalone), (display-mode: window-controls-overlay)',
  ).matches;
}
